import { Action, Dispatch } from 'redux'
import { db, FirebaseSnapshotType } from 'firebase/index'
import { dateToString } from 'lib/helper'
import { StoreShippingType } from 'types/storeShipping'
import { fetchStoreShippingsAction } from 'reducks/storeShipping/actions'

// スーパー管理者による注文の横断検索
const fetchStoreShippingGroup = (startDate: Date, endDate: Date) => {
  return async (dispatch: Dispatch<Action>) => {
    const storeShippings = await db
      .collectionGroup('store_shippings')
      .orderBy('scheduled_delivery_date', 'asc')
      .startAt(dateToString(startDate))
      .endAt(dateToString(endDate))
      .limit(100)
      .get()
      .then((snapshots) => {
        const storeShippings: StoreShippingType[] = []
        snapshots.forEach((snapshot: FirebaseSnapshotType) => {
          const data = snapshot.data() as StoreShippingType
          storeShippings.push(data)
        })
        return storeShippings
      })
    dispatch(fetchStoreShippingsAction(storeShippings))
  }
}

export default fetchStoreShippingGroup
